import { createFileRoute } from '@tanstack/react-router';

import { TOOL_GATES, ToolAccessGate } from 'shared/modules/capabilities';
import { LOCATION_DATA_UNAVAILABLE_PAGE } from 'shared/modules/country-support';

import { ReviewManager, reviewManagerSearchSchema } from 'features/reports/reviews/ReviewManager';

export const Route = createFileRoute('/_authenticated/locations/$id/_shell/reviews/manager/')({
  validateSearch: reviewManagerSearchSchema,
  component: ReviewManagerRoute
});

function ReviewManagerRoute() {
  const { id } = Route.useParams();
  const { tab, search, sites, ratings, period, sort } = Route.useSearch();

  return (
    <ToolAccessGate gate={TOOL_GATES.REVIEWS} locationId={id} page={LOCATION_DATA_UNAVAILABLE_PAGE.REVIEW_MANAGER}>
      <ReviewManager
        locationId={id}
        period={period}
        ratings={ratings}
        search={search}
        sites={sites}
        sort={sort}
        tab={tab}
      />
    </ToolAccessGate>
  );
}
